/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-07-24 16:15:49
 */
import Router from 'vue-router'
import Vue from 'vue'
import orgWorkbench from './modules/route-organizer'
import orgment from './modules/router-orgment'
import compmanage from './modules/router-compmanage'
import system from './modules/route-sys'
import systemLog from './modules/system-error'
// import workbench from './modules/workbench'
import taskManage from './modules/taskManage'
// import vipManage from './modules/router-vipPeople'
import liveManage from './modules/router-live'
import paidService from './modules/router-paidservice'
import helpManual from './modules/router-help'
import nationsJudge from './modules/nationsJudges'
import appSetting from './modules/appSetting'
Vue.use(Router)

// 静态路由
const constantRouter = [
  {
    path: '/',
    name: 'login',
    component: resolve => require(['@/views/Login.vue'], resolve),
    hidden: true
  },
  {
    path: '/update-password',
    name: 'update-password',
    component: resolve => require(['@/views/UpdatePassword.vue'], resolve),
    hidden: true
  }
]

// 权限路由
const asyncRouter = [
  orgWorkbench,
  compmanage,
  nationsJudge,
  taskManage,
  orgment,
  // vipManage,
  paidService,
  systemLog,
  system,
  liveManage,
  helpManual,
  appSetting,
  {
    path: '/drawLotsScreen',
    name: '抽取出场顺序',
    hidden: true,
    component: resolve =>
      require(['@/views/compmanage/manageMatch/DrawLotsOfScreen.vue'], resolve)
  },
  {
    path: '/drawSubjectScreen',
    name: '抽取演讲课题',
    hidden: true,
    component: resolve =>
      require([
        '@/views/compmanage/manageMatch/DrawSubjectOfScreen.vue'
      ], resolve)
  },
  {
    path: '/DrawScreenRouter',
    name: '抽取',
    hidden: true,
    component: resolve =>
      require(['@/views/compmanage/manageMatch/DrawScreenRouter.vue'], resolve),
    children: [
      {
        path: '/DrawStart',
        name: '开始抽取出场顺序',
        component: resolve =>
          require(['@/views/compmanage/manageMatch/DrawStart.vue'], resolve)
      },
      {
        path: '/DrawEnd',
        name: '结束抽取出场顺序',
        component: resolve =>
          require(['@/views/compmanage/manageMatch/DrawEnd.vue'], resolve)
      },
      {
        path: '/DrawRusult',
        name: '抽取顺序结果',
        component: resolve =>
          require(['@/views/compmanage/manageMatch/DrawRusult.vue'], resolve)
      },
      {
        path: '/successDraw',
        name: 'successDraw',
        component: resolve =>
          require(['@/views/compmanage/manageMatch/successDraw.vue'], resolve)
      }
    ]
  },
  {
    path: '/data-view',
    name: 'dataView',
    hidden: true,
    component: () => import('@/views/data-view')
  },
  {
    path: '*',
    name: 'notFound',
    hidden: true,
    component: resolve => require(['@/views/NotFound.vue'], resolve)
  }
]

// 创建路由实列
const createRouter = () =>
  new Router({
    mode: 'history', // history模式
    scrollBehavior: () => ({ y: 0 }), // 路由跳转滚动条回到顶部
    routes: constantRouter
  })

const router = createRouter()

// 重置路由（退出登录等）

const resetRouter = () => {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// 导出所有

export { constantRouter, asyncRouter, resetRouter }

export default router



// WEBPACK FOOTER //
// ./src/router/index.js